module.exports = __webpack_public_path__ + "eeafeb0fec4b2b31672ac508265f1712.svg";